module.exports = __webpack_public_path__ + "img/icon-invoice.3fd3498d.svg";